import { render } from "./status_bookmark_folder_menu.vue?vue&type=template&id=f001c0d6"
import script from "./status_bookmark_folder_menu.js?vue&type=script&lang=js&external"
export * from "./status_bookmark_folder_menu.js?vue&type=script&lang=js&external"
/* custom blocks */
import block0 from "./status_bookmark_folder_menu.scss?vue&type=custom&index=0&blockType=stlye&issuerPath=%2Fbuilds%2Fpleroma%2Fpleroma-fe%2Fsrc%2Fcomponents%2Fstatus_bookmark_folder_menu%2Fstatus_bookmark_folder_menu.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__